/**
 * Toast Service - Backwards compatibility wrapper
 * All logic now lives in useToast composable
 */

import { useToast } from "@/composables/ui/useToast";

// Export toastService for backwards compatibility
const toastInstance = useToast();

export const toastService = {
  success: toastInstance.success,
  error: toastInstance.error,
  danger: toastInstance.danger, // Alias for backwards compatibility
  warning: toastInstance.warning,
  info: toastInstance.info,
  clear: toastInstance.clear,
  clearAll: toastInstance.clearAll,
};

export default toastService;
